/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React from 'react';
import ServicesLayout from '../../components/ServicesLayout';

import UserInfo from '../userInfo/UserInfo';

const title = 'Rejestracaj konta WK';

export default {
  path: '/registerwk',
  async action(ctx) {
    const state = await ctx.store.getState();
    return {
      title,
      component: (
        <ServicesLayout active_panel="moje_dane" sidePanel>
          <UserInfo userData={state.user} />
        </ServicesLayout>
      ),
    }
  }
};




// WEBPACK FOOTER //
// src/routes/registerwk/index.js